/**
 * @generated SignedSource<<682a23b7348a86980d6fb2ed012a3360>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EthereumAddWalletFragment$data = {
  readonly viewer: {
    readonly user?: {
      readonly wallets: ReadonlyArray<{
        readonly chainAddress: {
          readonly address: string | null;
        };
      } | null> | null;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ManageWalletsModalFragment">;
  readonly " $fragmentType": "EthereumAddWalletFragment";
};
export type EthereumAddWalletFragment$key = {
  readonly " $data"?: EthereumAddWalletFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EthereumAddWalletFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EthereumAddWalletFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GalleryUser",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Wallet",
                  "kind": "LinkedField",
                  "name": "wallets",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "alias": null,
                        "args": null,
                        "concreteType": "ChainAddress",
                        "kind": "LinkedField",
                        "name": "chainAddress",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "address",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      "action": "NONE",
                      "path": "viewer.user.wallets.chainAddress"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "Viewer",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ManageWalletsModalFragment"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "50d12d1ed506ff9da4abd9e2a16fff15";

export default node;
